import { initializeApp } from "firebase/app";
// import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getFunctions} from 'firebase/functions';
// import { getMessaging } from "firebase/messaging";
// import 'firebase/functions';

const firebaseConfig = {

  apiKey: "AIzaSyDFXz8bS7OdBduChyu7Q67XsQcnBJ928UI",
  authDomain: "chillaxiaapp.firebaseapp.com",
  databaseURL: "https://chillaxiaapp-default-rtdb.firebaseio.com",
  projectId: "chillaxiaapp",
  storageBucket: "chillaxiaapp.firebasestorage.app",
  messagingSenderId: "5882860599",
  appId: "1:5882860599:web:18651dde94049f19471bb2",
  measurementId: "G-ZX12M9XVEM"

};

const app = initializeApp(firebaseConfig);


// const functions = functions(app);

// export { functions };

export const db = getFirestore(app);
export const auth = getAuth();
export const storage = getStorage(app);

export const functions = getFunctions(app)
// export const messaging = getMessaging(app);